export const ContainerTypes = {
  RFIS: 'issue',
  LBS: 'lbs',
  SUBMITTAL: 'submittal',
  REPORT: 'report',
  COST: 'cost',
  MEETING: 'meeting',
};
